import { render, staticRenderFns } from "./EditFunInfo.vue?vue&type=template&id=2480f286&scoped=true"
import script from "./EditFunInfo.vue?vue&type=script&lang=js"
export * from "./EditFunInfo.vue?vue&type=script&lang=js"
import style0 from "./EditFunInfo.vue?vue&type=style&index=0&id=2480f286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480f286",
  null
  
)

export default component.exports